import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import {
  getAccountDutyPayments,
  getAccountDutyPayment,
  createAccountDutyPayment,
  updateAccountDutyPayment,
  deleteAccountDutyPayment,
  completeAccountDutyPayment,
} from "api/accountDutyPaymentApi"

export const ACCOUNT_DUTY_PAYMENT_QUERY_KEY = "account-duty-payments"

export const useAccountDutyPayments = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_DUTY_PAYMENT_QUERY_KEY,
    getAccountDutyPayments,
    params,
    enabled
  )
}

export const useAccountDutyPayment = (id, enabled = true) => {
  return useResourceItem(ACCOUNT_DUTY_PAYMENT_QUERY_KEY, getAccountDutyPayment, id, enabled)
}

export const useCreateAccountDutyPayment = () => {
  return useCreateResource(createAccountDutyPayment, ACCOUNT_DUTY_PAYMENT_QUERY_KEY)
}

export const useEditAccountDutyPayment = () => {
  return useEditResource(updateAccountDutyPayment, ACCOUNT_DUTY_PAYMENT_QUERY_KEY)
}

export const useDeleteAccountDutyPayment = () => {
  return useDeleteResource(deleteAccountDutyPayment, ACCOUNT_DUTY_PAYMENT_QUERY_KEY)
}

export const useCompleteAccountDutyPayment = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: completeAccountDutyPayment,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [ACCOUNT_DUTY_PAYMENT_QUERY_KEY] }),
  })
}
